import { Clients } from "./types";
import { BASE_URL } from "./constants";
import { useFormeBackendApi } from "@modules/forme/queries";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useClientIntake = (options?: any) => {
  return useFormeBackendApi<Clients>({
    method: "GET",
    path: `${BASE_URL}/intake`,
    options,
  });
};

export { useClientIntake };
